// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"f3dc7ee9","608":"6b21b162","721":"feea495d","846":"fabd4b77","856":"fabd4b77"}[chunkId] + ".chunk.css";
};